export default {
  namespaced: true,
  state: () => ({
    lottery_id: undefined,
    exChange: {},
  }),
  mutations: {
    SET_LOTTERY_ID(state, id) {
      state.lottery_id = id;
    },
    SET_EX_CHANGE(state, obj) {
      state.exChange = obj;
    }
  },
  actions: {},
}